import { SiteStatus } from "@anu-its/cat-grpc-pb/js/anu/cat/enums_pb";
import { StateTransition } from "@anu-its/cat-grpc-pb/js/anu/cat_app/enums_pb";

export const getTargetStateFromTransition = (
  stateTransition: StateTransition,
) =>
  ({
    [StateTransition.UNSPECIFIED]: SiteStatus.UNSPECIFIED,
    [StateTransition.CREATE_DRAFT]: SiteStatus.DRAFT,
    [StateTransition.CREATE_PROVISIONED]: SiteStatus.PROVISIONED,
    [StateTransition.PROVISION]: SiteStatus.PROVISIONED,
    [StateTransition.PUBLISH]: SiteStatus.PUBLISHED,
    [StateTransition.UNPUBLISH]: SiteStatus.PROVISIONED,
  })[stateTransition];

export const siteStatusLabel = (status: SiteStatus) =>
  ({
    [SiteStatus.UNSPECIFIED]: "Unknown",
    [SiteStatus.UNCLAIMED]: "Unclaimed",
    [SiteStatus.DRAFT]: "Draft",
    [SiteStatus.PROVISIONED]: "Provisioned",
    [SiteStatus.PUBLISHED]: "Published",
    [SiteStatus.SUSPENDED]: "Suspended",
  })[status];

export const siteStatusKey = (label: string) =>
  ({
    Unknown: SiteStatus.UNSPECIFIED,
    Unclaimed: SiteStatus.UNCLAIMED,
    Draft: SiteStatus.DRAFT,
    Provisioned: SiteStatus.PROVISIONED,
    Published: SiteStatus.PUBLISHED,
    Suspended: SiteStatus.SUSPENDED,
  })[label];

export const statusBadgeVariant: Record<
  SiteStatus,
  "negative" | "notice" | "positive" | "informative" | "neutral"
> = {
  [SiteStatus.UNCLAIMED]: "neutral",
  [SiteStatus.DRAFT]: "neutral",
  [SiteStatus.PROVISIONED]: "informative",
  [SiteStatus.PUBLISHED]: "positive",
  [SiteStatus.UNSPECIFIED]: "negative",
  [SiteStatus.SUSPENDED]: "negative",
};

export const dashboardSiteStatuses: SiteStatus[] = [
  SiteStatus.DRAFT,
  SiteStatus.PROVISIONED,
  SiteStatus.PUBLISHED,
  SiteStatus.SUSPENDED,
];
